<template>
  <section class="section scPointHistory" :class="{open: show}">
    <transition name="fade">
      <div class="leftBackdrop" v-if="show"
        v-on:click="close"></div>
    </transition>
    <div class="rightContent">
      <div class="tree"></div>
      <div class="rightContentIn">
        <div class="header">
          <div class="backBtn" v-on:click="close"></div>
          <h4>Riwayat perolehan point</h4>
        </div>
        <div class="contentSc">
          <div class="menuCnt">
            <div class="menuItem loadingPrice" v-if="loading"></div>
            <div v-else>
              <div class="menuItem" v-for="(item, i) in history" :key="i">
                <div class="menuIcon" :class="item.type"></div>
                <p>{{item.dateCreated | moment("ddd, D MMM YYYY HH:mm")}}</p>
                <h4 v-if="item.type === 'check_body_composition'">
                  Cek body composition
                </h4>
                <h4 v-else-if="item.type === 'upload_photo'">
                  Upload foto
                </h4>
                <h4 v-else-if="item.type === 'upload_activity'">
                  Upload aktifitas
                </h4>
                <h4 v-else-if="item.type === 'upload_product_favorite'">
                  Upload produk favorit nutrilite
                </h4>
                <h4 v-else-if="item.type === 'upload_food_menu'">
                  Upload menu makanan
                </h4>
                <h4 v-else-if="item.type === 'game'">
                  Bermain game
                </h4>
                <h4 v-else-if="item.type === 'video'">
                  {{item.content.title}} - {{item.video.media.name}}
                </h4>
                <h4 v-else-if="item.type === 'quiz'">
                  Quiz - {{item.content.title}}
                </h4>
                <h4 v-else-if="item.type === 'upload_screenshot'">
                  Upload screenshot - {{item.content.title}}
                </h4>
                <h4 v-else-if="item.type === 'breakfast_photo'">
                  Upload foto sarapan - {{item.content.title}}
                </h4>
                <h4 v-else-if="item.type === 'fitNMove'">
                  Ikutan FitNMove - {{item.content.title}}
                </h4>
                <div class="point">{{item.point}}<sup>pts</sup></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Confirmation ref="confirmDialog"/>
  </section>
</template>

<script>
import Confirmation from '@/components/Confirmation.vue';

export default {
  name: 'home',
  components: { Confirmation },
  data() {
    return {
      loading: true,
      history: [],
      show: false,
    };
  },
  methods: {
    doNothing() {},
    open() {
      this.show = true;
      this.loading = true;
      this.getData();
    },
    close() { this.show = false; },
    getData() {
      this.$http.get(this.$config.uri('user/point/history')).then((r) => {
        this.loading = false;
        this.history = (r.data.status === 200) ? r.data.data : [];
      });
    },
  },
  mounted() {},
};
</script>

<style scoped lang="scss">
.section.scPointHistory{
  position: fixed;
  right: 0; top: 0; bottom: 0;
  left: auto;
  padding: 0;
  z-index: 9997;
  .rightContent{
    position: fixed;
    right: 0; top: 0; bottom: 0;
    background-color: #e6e1c1;

    background-color: #b7e4c9;
    background-image: linear-gradient(#fff 0, #e2fcec 50%, #fff);

    padding: 0 0 40px;
    box-sizing: border-box;
    width: 400px;
    z-index: 3;
    right: -400px;
    transition: all .45s ease;
    @media (max-width: 768px) {
      top: 60px;
    }
    @media (max-width: 680px) {
      width: 96%; right: -96%;
    }
    .tree{
      position: absolute;
      left: 0; right: -10px; bottom: 0; top: 0;
      background-image: url(../assets/high-five.png);
      background-size: auto 160px;
      background-position: right bottom;
      background-repeat: no-repeat;
    }
  }
  .leftBackdrop{
    position: fixed;
    left: 0; right: 0; top: 0; bottom: 0;
    background-color: #000;
    background-color: rgba(0,0,0,.7);
    z-index: 1;
    transition: all .3s ease;
  }
  &.open{
    .rightContent{
      right: 0;
    }
  }
  .header{
    position: relative;
    padding: 5px 20px;
    z-index: 7;
    box-shadow: 0 0 4px rgba(0, 0, 0, .2);
    backdrop-filter: blur(20px);
    .backBtn{
      width: 40px; height: 40px;
      border-radius: 50%;
      background-color: #fff;
      background-image: url(../assets/arrow-next-black.png);
      background-size: 20px auto;
      background-position: center;
      background-repeat: no-repeat;
      transition: all .3s ease;
      cursor: pointer;
      &:hover{
        background-color: #f5f5f5;
      }
    }
    h4{
      font-size: 18px;
      margin: 0;
      color: #444;
      position: absolute;
      left: 80px; top: 13px; right: 10px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .contentSc{
    position: absolute;
    left: 0; right: 0; top: 0; bottom: 0;
    overflow-y: auto;
    z-index: 5;
    padding: 65px 10px 10px;
  }
  .menuCnt{
    padding: 0 0 40px;
    h4{
      margin: 0 20px 6px;
    }
    .divider{
      height: 20px;
    }
    .menuItem{
      padding: 12px 100px 14px 64px;
      font-weight: bold;
      color: #444;
      position: relative;
      background-color: rgba(255, 255, 255, .75);
      backdrop-filter: blur(20px);
      // background-image: linear-gradient(to left, #8EC642, #669922);
      // color: #fff;
      margin: 0 10px 10px;
      border-radius: 5px;
      font-size: 16px;
      box-sizing: border-box;
      .menuIcon{
        position: absolute;
        left: 10px; top: 13px; height: 42px; width: 42px;
        border-radius: 50%;
        background-position: center;
        background-size: cover;
        background-repeat: no-repeat;
        background-color: #ddd;
        // background-color: rgba(0, 0, 0, .1);
        opacity: .6;
        background-size: 26px auto;
        &.check_body_composition{
          background-image: url(../assets/body.png);
        }
        &.fitNMove{
          background-image: url(../assets/zoom-meeting-logo.png);
          opacity: 1;
        }
        &.upload_food_menu,
        &.upload_product_favorite,
        &.upload_activity,
        &.upload_photo,
        &.upload_screenshot,
        &.breakfast_photo{
          background-image: url(../assets/upload-image.png);
          background-position: 10px 9px;
        }
        &.game{
          background-image: url(../assets/games.png);
        }
        &.video{
          background-image: url(../assets/video-black.png);
          background-size: 20px auto;
        }
        &.quiz{
          background-image: url(../assets/quiz.png);
          background-size: 24px auto;
        }
      }
      .point{
        position: absolute;
        right: 20px; top: 10px;
        font-size: 24px;
        sup{
          font-weight: normal;
          font-size: 14px;
          color: #767676;
          margin-left: 3px;
        }
      }
      &.loadingPrice{
        background-color: rgba(255, 255, 255, 0.5);
        background-color: transparent;
        background-image: url(../assets/loading.svg);
        background-position: center;
        background-repeat: no-repeat;
        background-size: 36px auto;
        height: 60px;
      }
      h4{
        font-size: 16px;
        margin: 0;
      }
      p{
        margin: 0 0 4px;
        font-weight: normal;
        font-size: 14px;
        color: #767676;
      }
    }
  }
}
</style>
